const BudgetDivTitle = (props) => {
  return (
    <h2 id={props.id} className={props.className}>
      {props.divisionNumber} - {props.divisionName}
    </h2>
  );
};

export default BudgetDivTitle;
